<template>
  <div class="Cards" :class="{ 'is-open': isOpen }">
    <div class="swiper-container Cards__container" ref="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide Cards__slide">
          <div class="Cards__trigger" />
          <div class="Cards__chevron" @click="close" :class="{ 'is-closed': !isOpen }" />
          <div class="Cards__inner" :class="{ 'is-rabais-teaser': shared < 2, 'is-rabais': shared > 1 }">
            <div class="Cards__box">
              <img v-if="shared < 2" :src="require('./img/box.png')" />
              <img v-else :src="require('./img/off_' + lang  + '.png')" />
            </div>
            <div class="Cards__title" v-html="slideRabais.title" />
            <div class="Cards__description">{{ slideRabais.description }}</div>
            <img class="Cards__barcode" v-if="shared > 1" :src="require('./img/barcode.png')" />
          </div>
        </div>
        <div class="swiper-slide Cards__slide" v-for="slide in trans('slides')">
          <div class="Cards__trigger" />
          <div class="Cards__chevron" @click="close" :class="{ 'is-closed': !isOpen }" />
          <div class="Cards__inner" :class="['is-' + slide.id]">
            <div class="Cards__box"><img :src="require('@/pages/marker/markers/' + (slide.id == 'singerb' ? 'singer' : slide.id)  + '/icon_black.png')" /></div>
            <div class="Cards__title" v-html="slide.title" />
            <router-link :to="{ name: 'marker.' + lang, params: { marker: slide.id == 'singerb' ? 'singer' : slide.id } }" class="Cards__btn Btn disable-force-touch is-border-black">
              <img class="is-camera" :src="require('./img/camera.png')" />{{ trans('btn') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
require('swiper/dist/css/swiper.css')
import '@/commons/js/gsap/ThrowPropsPlugin'

export default {
  name: 'Cards',
  props: ['markerSelected'],
  data: () => ({
    icons: ['map', 'camera', 'map'],
    activeIndex: 0,
    isOpen: true,
    y: 0
  }),
  computed: {
    shared() { return this.$store.getters['user/shared'] },
    slideRabais() {
      if(this.shared > 1)
        return this.trans('rabais')[2]

      return this.trans('rabais')[this.shared]
    }
  },
  watch: {
    y() {
      this.isOpen = this.y == 0
    },
    isOpen() {
      const activeSlide = this.$el.querySelector('.swiper-slide-active')
      TweenLite.to(this.$el, 1, { y: this.isOpen ? 0 : this.getBottom(), ease: Expo.easeOut })
    },
    markerSelected() {
      this.activeIndex = _.findIndex(this.trans('slides'), s => s.id == this.markerSelected) + 1
    },
    activeIndex() {
      const slide = this.trans('slides')[this.activeIndex - 1]
      if(!slide) return this.$parent.markerSelected = null

      this.$swiper.slideTo(this.activeIndex, 1000)
      this.$parent.markerSelected = slide.id

      this.isOpen = true
    }
  },
  translations: {
    en: {
      btn: 'TAKE A PICTURE',
      rabais: [
				{
					title: 'Unlock your 15% discount by sharing two photos on Facebook',
					description: 'Valid one time, today only. Not valid for food or beverages.',
				},
				{ title: 'Unlock your 15% discount on merchandise today by sharing one additional photo on Facebook.' },
				{ title: '', description: "Valid one time today and for merchandise only. Not valid for food and beverages."},
      ],
      slides: [
        { id: 'trone', title: 'Look for this marker<br> under the big top.' },
				// { id: 'crown', title: 'Look for this marker<br> under the big top.' },
				{ id: 'singer', title: 'Look for this marker<br> near restrooms.' },
				{ id: 'card', title: 'Look for this marker<br> near the VIP tent.' },
				{ id: 'mrfleur', title: 'Look for this marker<br> near the VIP tent.' },
				// { id: 'singerb', title: 'Look for this marker<br> outside the main gates.' },
      ],
    },
    fr: {
      btn: 'PRENDRE UNE PHOTO',
      rabais: [
				{
					title: 'Obtenez votre 15% de rabais en partageant deux photos sur Facebook',
					description: "Valide une fois, aujourd'hui seulement. Non valide pour les aliments et les boissons.",
				},
				{ title: "Obtenez votre 15% de rabais sur la marchandise seulement aujourd'hui en partageant une photo additionnelle sur Facebook." },
				{ title: '', description: "Valide une fois aujourd'hui et sur la marchandise seulement. Non valide pour les aliments et les boissons."},
      ],
      slides: [
				{ id: 'trone', title: 'Repérez cet icône<br> sous le chapiteau.' },
				// { id: 'crown', title: 'Repérez cet icône<br> devant le chapiteau.' },
				{ id: 'singer', title: 'Repérez cet icône<br> près des toilettes.' },
				{ id: 'card', title: 'Repérez cet icône<br> près de la tente VIP.' },
				{ id: 'mrfleur', title: 'Repérez cet icône<br> près de la tente VIP' },
				// { id: 'singerb', title: "Repérez cet icône<br> à l'extérieur des portes principales." },
      ],
    }
  },
  mounted() {
    this.$swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1.2,
      spaceBetween: 0,
      centeredSlides: true,
      spaceBetween: 10,
      autoHeight: true,
      on: {
        slideChange: () => {
          this.activeIndex = this.$swiper.activeIndex
        }
      }
    })

    // this.$drag = Draggable.create(this.$el, {
    //   type: 'y',
    //   throwProps: true,
    //   trigger: '.Cards__trigger',
    //   onDragEnd: () => {
    //     this.y = this.$drag.y
    //   },
    //   onDragEnd: () => this.y = this.$drag.y,
    //   onThrowComplete: () => this.y = this.$drag.y
    // })[0]

    // this.$nextTick(this.setDragBound)
  },
  methods: {
    close(e) {
      e.stopPropagation()
      this.isOpen = !this.isOpen
    },
    setDragBound() {
      // const activeSlide = this.$el.querySelector('.swiper-slide-active')
      // this.$drag.applyBounds({ minY: 0, maxY: this.getBottom() })
    },
    getBottom() {
      const activeSlide = this.$el.querySelector('.swiper-slide-active')
      return activeSlide.offsetHeight - 35
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Cards
  position fixed
  width 100%
  z-index 9
  bottom 0px
  left 0

  .Btn
    box-sizing border-box
    width 100%
    border 3px solid black
    color black
    line-height 48px
    img
      height 24px
      width 24px
      position relative
      top 5px
      margin-right 10px

  &__trigger
    position absolute
    top 0px
    height 25px
    left 0px
    right 0px
    z-index 9
    display none

  &__chevron
    position absolute
    right 0px
    top 0px
    padding 15px
    background-image url('./img/chevron.png')
    background-size contain
    background-position center center
    background-repeat no-repeat
    background-size 16px 10px
    width 16px
    height 10px
    transition transform 1s
    transform rotate(180deg)
    &.is-closed
      transform rotate(0deg)

  &__close
    position absolute
    left 50%
    transform translateX(-50%)
    top 10px
    width 48px
    background rgba(grey, .2)
    border-radius 3px
    height 3px

  // &__container
  //   height 200px

  &__box
    width 34px
    float left
    position relative

  &__slide
    background white
    border-top-left-radius 20px
    border-top-right-radius 20px
    margin-bottom 0
    margin-top auto
    padding-bottom 10px

  &__inner
    padding 35px 25px 10px
    &.is-rabais
      text-align center
      .Cards__description
        margin-left 0
        margin-top 20px
        margin-bottom 30px
      .Cards__box
        float none
        width 144px
        height 144px
        margin 0 auto
      .Cards__barcode
        width 200px
        margin-bottom 20px
        height 60px
    &.is-rabais-teaser
      padding-left 15px
      padding-right 15px
      .Cards__title
      .Cards__description
        margin-left 60px
      .Cards__box
        width 44px
    &.is-crown
      .Cards__box
        top 5px

  &__title
    color black
    font-size 16px
    font-weight 700
    line-height 24px
    margin-left 50px

  &__description
    color #A09C94
    font-size 13px
    margin 10px 0
    line-height 22px
    letter-spacing .19px
    margin-left 50px


</style>
